import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';

import Highcharts from 'highcharts/highstock'
import AnnotationsFactory from "highcharts/modules/annotations";
import HighchartsReact from 'highcharts-react-official'
import mergeDeep from '../../../../utils/mergeDeep';
import * as ChartConsts from '../../../ChartSettings/ChartSettings'

//import bellCurve from "highcharts/modules/histogram-bellcurve"

// init the module
AnnotationsFactory(Highcharts);
//bellCurve(Highcharts);

const OnlineHighchartsLineForwardRef = forwardRef((props, ref) => {  
  const chartComponentRef = useRef(null);
  const chartDataRef = useRef({});  
  const DEFAULT_SERIES_NAME = 'series-data';


  useImperativeHandle(ref, () => ({
    setInitialData(data, seriesSettings) {
      chartDataRef.current[(seriesSettings && seriesSettings.seriesId) ?? DEFAULT_SERIES_NAME] = data;
      let chart = chartComponentRef.current.chart;
      let seriesId = (seriesSettings && seriesSettings.seriesId) ?? DEFAULT_SERIES_NAME;    

      let newSeries =
      {
        id: seriesId,
        data: data,
        name: (seriesSettings && seriesSettings.name) ?? props.seriesName,
        color: (seriesSettings && seriesSettings.color) ?? undefined,        
        yAxis: (seriesSettings && seriesSettings.yAxisId) ?? 0,
        zoneAxis: (seriesSettings && seriesSettings.zoneAxis) ?? undefined,
        zones: (seriesSettings && seriesSettings.zones) ?? undefined,
        type: (seriesSettings && seriesSettings.type) ?? undefined        
      };

      if (chart.get(seriesId))
        chart.get(seriesId).update(newSeries);
      else
        chart.addSeries(newSeries);
    },
    clearAllSeries() {
      const chart = chartComponentRef.current?.chart;
      if (chart) {
        // Remove all series
        while(chart.series.length > 0) {
          chart.series[0].remove(false);
        }
        chart.redraw();
      }
    },
    updateYAxes(yAxesConfig) {
      const chart = chartComponentRef.current?.chart;
      if (chart) {
        // Remove existing y-axes except the first one
        while (chart.yAxis.length > 1) {
          chart.yAxis[chart.yAxis.length - 1].remove(false);
        }
        
        // Update or add y-axes
        yAxesConfig.forEach((axisConfig, index) => {
          if (index === 0 && chart.yAxis[0]) {
            // Update the first axis
            chart.yAxis[0].update(axisConfig, false);
          } else {
            // Add new axes
            chart.addAxis(axisConfig, false, false);
          }
        });
        
        chart.redraw();
      }
    }
  }));

  useEffect(() => {
    //console.log('accumulation mode:', props.mode);    

  }, []);

  
 
  const newOptions = {
    chart: {
      type: 'line',
      zoomType: 'xy',
      zooming: {
        mouseWheel: {
          enabled: false
        }
      }
    }
  };

  const getOptions = () => {
    let base = ChartConsts.baseChartOptions;    

    let common =  mergeDeep(base, newOptions);
    
    // For multiple series mode, ensure legend is visible
    if (props.multipleSeriesMode) {
      common.legend = { ...common.legend, enabled: true };
    }
    
    if (props.specificChartOptions) {      
      return mergeDeep(common, props.specificChartOptions);
    }

    return common;
  }
  
  return (
    <>
      <HighchartsReact
        ref={chartComponentRef}
        highcharts={Highcharts}
        constructorType={'chart'}
        options={getOptions()}
      />

    </>
  )


});

OnlineHighchartsLineForwardRef.displayName = 'OnlineHighchartsLineForwardRef';

export const OnlineHighchartsLine = React.memo(OnlineHighchartsLineForwardRef);